export default __webpack_public_path__ + "static/media/arrow (2).e69bf1d9.svg";